const CACHE_KEY = 'local_led_display_config';
let memoryConfig = null;
let loadPromise = null;

const normalizeConfig = (config) => {
  if (!config || typeof config !== 'object') return null;

  return {
    enableLedDisplay: config.enableLedDisplay === true || config.enableLedDisplay === 1 || config.enableLedDisplay === '1' || config.enableLedDisplay === 'true',
    ledPort: String(config.ledPort || '').trim(),
    ledBaudRate: String(config.ledBaudRate || '2400').trim() || '2400',
    ledDisplayValue: String(config.ledDisplayValue || 'SALE_TOTAL').trim() || 'SALE_TOTAL'
  };
};

const readCache = () => {
  try {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return normalizeConfig(JSON.parse(raw));
  } catch (e) {
    console.warn('[LedConfig] Failed to read cache:', e);
    return null;
  }
};

const writeCache = (config) => {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(CACHE_KEY, JSON.stringify(config));
    memoryConfig = config;
  } catch (e) {
    console.warn('[LedConfig] Failed to write cache:', e);
  }
};

const mergeSettings = (base = {}, override = null) => {
  if (!override) return base || {};
  return {
    ...(base || {}),
    enableLedDisplay: override.enableLedDisplay,
    ledPort: override.ledPort,
    ledBaudRate: override.ledBaudRate,
    ledDisplayValue: override.ledDisplayValue
  };
};

const LedConfig = {
  getCached() {
    if (memoryConfig) return memoryConfig;
    memoryConfig = readCache();
    return memoryConfig;
  },

  getEffective(base = {}) {
    return mergeSettings(base, this.getCached());
  },

  async load() {
    if (loadPromise) {
      return loadPromise;
    }

    loadPromise = (async () => {
    try {
      if (window.ledConfigAPI && window.ledConfigAPI.getConfig) {
        const result = await window.ledConfigAPI.getConfig();
        if (result?.ok) {
          const normalized = normalizeConfig(result.config);
          if (normalized) {
            writeCache(normalized);
            return normalized;
          }
        }
      }
    } catch (e) {
      console.warn('[LedConfig] Failed to load LED config file:', e);
    }

      return this.getCached();
    })();

    try {
      return await loadPromise;
    } finally {
      loadPromise = null;
    }
  },

  async save(config) {
    const normalized = normalizeConfig(config);
    if (!normalized) {
      return { ok: false, error: 'Invalid LED config' };
    }

    if (window.ledConfigAPI && window.ledConfigAPI.saveConfig) {
      const result = await window.ledConfigAPI.saveConfig(normalized);
      if (!result?.ok) {
        return result || { ok: false, error: 'Failed to save LED config' };
      }
    }

    writeCache(normalized);
    return { ok: true, config: normalized };
  }
};

if (typeof window !== 'undefined') {
  setTimeout(() => {
    LedConfig.load().catch((e) => console.warn('[LedConfig] Background load failed:', e));
  }, 0);
}

export default LedConfig;
